/* import __COLOCATED_TEMPLATE__ from './dc-tab.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';

export default class DcTab extends Component {
    tagName = '';

    @service intl;
    @service('data') model;

    dcInputSignalBodyArgs = {};

    init() {
        super.init();

        this.dcInputSignalBodyArgs = {
            analogFrontEndDesignArticleLink: this.intl.t('urls.articles.frontEndDesign'),
            analogLtSpiceSimulatingSarArticleLink: this.intl.t('urls.articles.ltSpiceSimulatingSar'),
        };
    }
}
